// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2zVJe","content":"styles_content__2WXaJ"};